import React, { useMemo } from "react";

import { IActiveLearningIssue } from "../../../../../../state";
import TextArea from "../../../../../../atoms/ActiveLearning/TextArea";
import FeedbackTextArea from "../../../../../../molecules/ActiveLearning/FeedbackTextArea";
import styles from "../../../ActiveLearningIssue.module.scss";

type Issue1MaterialProps = {
  issue?: IActiveLearningIssue;
};

export const Issue1Material = (props: Issue1MaterialProps) => {
  const question1 = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 1);
  }, [props.issue?.questions]);

  const question2 = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 2);
  }, [props.issue?.questions]);

  return (
    <div className={styles.issue}>
      <div className={styles.header}>
        <span className={styles.no}>
          WORK
          {props.issue?.no && props.issue?.no < 10
            ? `0${props.issue?.no}`
            : props.issue?.no}
        </span>
        <p className={styles.title}>{props.issue?.title}</p>
        <p className={styles.read}>
          ターゲットについて深く考えるほど、その人が抱えている問題に近づくことができる。
          <br />
          まずは、ターゲットがどんな人かを考えて、その行動を洗い出そう。
          <br />
          洗い出した行動を参考に、ターゲットが感じる「もっとこうだったらいのに」や「こうしたい」を考えよう。
        </p>
      </div>
      {question1 && (
        <div className={styles.themEntry}>
          <p className={styles.title}>{question1.title}</p>
          <div className={styles.textAreaWrapper}>
            <TextArea />
          </div>
        </div>
      )}
      {question2 && <FeedbackTextArea />}
    </div>
  );
};

export default Issue1Material;
